import React from 'react';
import styles from "./homepagefooter.module.css"
import facebooklogo from "./../../assets/facebooks2.png"
import tiktoklogo from "./../../assets/tiktoks2.png"
import ImageWithFallback from '../ImageWithFallback';

const HomePageFooter = () => {
  return (
    <div className={`pt-5 ${styles.bg}`}>
      <div className="container">
        <div className="row">
          <div className="col-md-3">
            <h5>CHĂM SÓC KHÁCH HÀNG</h5>
            <ul className="list-unstyled">
              <li><a href="#" className={styles.link}>Trung Tâm Trợ Giúp</a></li>
              <li><a href="#" className={styles.link}>bHive Blog</a></li>
              <li><a href="#" className={styles.link}>Hướng Dẫn Mua Hàng</a></li>
              <li><a href="#" className={styles.link}>Hướng Dẫn Bán Hàng</a></li>
              <li><a href="#" className={styles.link}>Thanh Toán</a></li>
              <li><a href="#" className={styles.link}>bHive điểm</a></li>
              <li><a href="#" className={styles.link}>Vận Chuyển</a></li>
              <li><a href="#" className={styles.link}>Trả Hàng & Hoàn Tiền</a></li>
              <li><a href="#" className={styles.link}>Chăm Sóc Khách Hàng</a></li>
              <li><a href="#" className={styles.link}>Chính Sách Bảo Hành</a></li>
            </ul>
          </div>
          <div className="col-md-3">
            <h5>VỀ BHIVE</h5>
            <ul className="list-unstyled">
              <li><a href="#" className={styles.link}>Giới Thiệu Về bHive Việt Nam</a></li>
              <li><a href="#" className={styles.link}>Tuyển Dụng</a></li>
              <li><a href="terms-of-service" className={styles.link}>Điều Khoản bHive</a></li>
              <li><a href="private-policy" className={styles.link}>Chính Sách Bảo Mật</a></li>
              <li><a href="#" className={styles.link}>Chính Hãng</a></li>
              <li><a href="#" className={styles.link}>Kênh Người Bán</a></li>
              <li><a href="#" className={styles.link}>Flash Sales</a></li>
              <li><a href="#" className={styles.link}>Chương Trình Tiếp Thị Liên Kết bHive</a></li>
              <li><a href="#" className={styles.link}>Liên Hệ Với Truyền Thông</a></li>
            </ul>
          </div>
          <div className="col-md-3">
            <h5>THANH TOÁN</h5>
            <div className="d-flex flex-wrap">
              <ImageWithFallback loading="lazy" src="https://tse4.mm.bing.net/th?id=OIP.DCgfEJDZZDka6j0wAAPFrAAAAA&pid=Api&P=0&h=220" alt="Visa" className="img-fluid m-1" width="50" />
              <ImageWithFallback loading="lazy" src="https://tse2.mm.bing.net/th?id=OIP.Kx0t1i9GWW3N9i6s_SRv7wHaEX&pid=Api&P=0&h=220" alt="Mastercard" className="img-fluid m-1" width="50" />
              <ImageWithFallback loading="lazy" src="https://tse3.mm.bing.net/th?id=OIP.gbLTwWArSlI9Z6hR19WNtwHaFj&pid=Api&P=0&h=220" alt="Amex" className="img-fluid m-1" width="50" />
              <ImageWithFallback loading="lazy" src="https://tse2.mm.bing.net/th?id=OIP.Hqh3wztssUDZhLrvrbIQNwHaHU&pid=Api&P=0&h=220" alt="COD" className="img-fluid m-1" width="50" />
              <ImageWithFallback loading="lazy" src="https://tse4.mm.bing.net/th?id=OIP.k0MsEss0i979zCfUZfrFJAHaFs&pid=Api&P=0&h=220" alt="JCB" className="img-fluid m-1" width="50" />
              <ImageWithFallback loading="lazy" src="https://tse4.mm.bing.net/th?id=OIP.Gzhh_V3OugIzb-UO6wDh1gHaET&pid=Api&P=0&h=220" alt="Installment" className="img-fluid m-1" width="50" />
            </div>
            <h5>ĐƠN VỊ VẬN CHUYỂN</h5>
            <div className="d-flex flex-wrap">
              <ImageWithFallback loading="lazy" src="https://tse2.mm.bing.net/th?id=OIP.IKljguNvqpRjptKoKtG_2QHaHa&pid=Api&P=0&h=220" alt="SPX" className="img-fluid m-1" width="50" />
              <ImageWithFallback loading="lazy" src="https://tse1.mm.bing.net/th?id=OIP.Z1cUidrrczHKgIaj_pwCZQHaEo&pid=Api&P=0&h=220" alt="GiaoHangTietKiem" className="img-fluid m-1" width="50" />
              <ImageWithFallback loading="lazy" src="https://tse4.mm.bing.net/th?id=OIP.FB0TgCgToEy0lzMC9SWwtAAAAA&pid=Api&P=0&h=220" alt="ViettelPost" className="img-fluid m-1" width="50" />
              <ImageWithFallback loading="lazy" src="https://tse1.mm.bing.net/th?id=OIP.HbnZ3UqXjXV32YQhds8oYQHaFC&pid=Api&P=0&h=220" alt="VNPost" className="img-fluid m-1" width="50" />
              <ImageWithFallback loading="lazy" src="https://tse3.mm.bing.net/th?id=OIP.Zs1qvcmpwhgtzn5o3DJtZwHaD4&pid=Api&P=0&h=220" alt="J&T Express" className="img-fluid m-1" width="50" />
              <ImageWithFallback loading="lazy" src="https://tse4.mm.bing.net/th?id=OIP.YMa_RdJbJq3cjFYc4RNKqwHaEs&pid=Api&P=0&h=220" alt="GrabExpress" className="img-fluid m-1" width="50" />
              <ImageWithFallback loading="lazy" src="https://tse4.mm.bing.net/th?id=OIP.EcozfuH3xhkZp2QHZLHTjgHaEK&pid=Api&P=0&h=220" alt="Ninja Van" className="img-fluid m-1" width="50" />
              <ImageWithFallback loading="lazy" src="https://tse2.mm.bing.net/th?id=OIP.sBxPnD2RkC3khSywZG0V-gHaHa&pid=Api&P=0&h=220" alt="Best Express" className="img-fluid m-1" width="50" />
              <ImageWithFallback loading="lazy" src="https://tse2.mm.bing.net/th?id=OIP.FiQTCY0ZSkvI9kLb5vzkDQHaEK&pid=Api&P=0&h=220" alt="Ahamove" className="img-fluid m-1" width="50" />
            </div>
          </div>
          <div className="col-md-3">
            <h5>THEO DÕI CHÚNG TÔI TRÊN</h5>
            <ul className="list-unstyled">
              <li>
                <a href="#" className={styles.link}>
                  <ImageWithFallback loading="lazy" src={facebooklogo} width={'20px'} alt="connect with facebook" /> Facebook
                </a>
              </li>
              <li>
                <a href="#" className={styles.link}>
                  <ImageWithFallback loading="lazy" src={tiktoklogo} width={'20px'} alt="connect with tiktok" /> Tiktok
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePageFooter;
